module.exports = __webpack_public_path__ + "images/grinning-smiling-squinting-eyes.png";